import { rem } from '../../../utils/rem';
export var MuiFormControlLabel = {
    styleOverrides: {
        root: {
            minHeight: rem(30),
            marginInlineStart: rem(-11),
            marginInlineEnd: rem(16),
            height: 'auto',
        },
    },
};
